import { createContext } from 'react';

const PersonalAddressContext = createContext();

export default PersonalAddressContext;
